var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSameButtonBgHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.6 685.8",
    style: {
      enableBackground: "new 0 0 666.6 685.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,685.8h200c166.7,0,233.3-66.7,233.3-233.3V233.3C666.7,66.7,600,0,433.3,0h-200C66.7,0,0,66.7,0,233.3 v219.2C0,619.2,66.7,685.8,233.3,685.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.7,387.2c-1.2-2.8-1.8-5.6-1.8-8.4c0-8.5,6.1-14.2,14.7-14.2c6.6,0,11,2.3,15.3,9 c4.5,8.3,13.5,11.8,24.2,11.8c13.2,0,21.8-5.9,21.8-14c0-7.4-5.6-11.2-21.4-14.2l-13.8-2.6c-26.5-5-40.3-18-40.3-38.3 c0-25.7,22.2-42.2,52.9-42.2c25.5,0,44.1,9.8,50.6,26.7c0.9,2.3,1.4,4.5,1.4,7.3c0,7.8-5.7,13.1-14.2,13.2c-7.4,0-12-2.7-16-9.1 c-4.3-8.3-11.7-11.5-21.5-11.5c-12.3,0-19.5,5.5-19.5,13.4c0,7,6,10.9,20.5,13.7l13.7,2.6c28.4,5.4,41.3,17,41.3,37.9 c0,26.8-20.9,43.7-56,43.7C99.7,411.8,82.2,400.9,76.7,387.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.1,395.4c0-2.9,0.9-7,2.4-11.1l32.9-90.3c4.9-13.6,13.1-19.7,26.3-19.7c13.9,0,22.1,5.9,27.1,19.7 l33.1,90.3c1.6,4.3,2.2,7.5,2.2,11c0,9.5-7.1,16.2-17,16.2c-9.8,0-14.9-4.4-17.8-15.3l-4.5-14.8h-45.6l-4.5,14.2 c-3.2,11.3-8.3,15.9-17.3,15.9C198.6,411.5,192.1,405.4,192.1,395.4z M269.4,355.9l-15.6-51.3h-0.7l-15.1,51.3H269.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.3,395.8v-99.6c0-13.9,7.9-22,22-22c11.8,0,18.2,4.8,23,17.3l27.8,70.3h0.7l27.7-70.3 c4.9-12.5,11.3-17.3,23.2-17.3c13.9,0,21.9,7.9,21.9,22v99.6c0,10-5.4,15.7-15,15.7c-9.4,0-14.9-5.7-14.9-15.7v-69.5h-0.6 l-29.6,73.3c-2.5,6.3-6.5,9.1-12.9,9.1s-10.7-2.9-13.1-9.1l-29.5-73.3h-0.7v69.5c0,10-5.4,15.7-14.9,15.7 C337.8,411.5,332.3,405.8,332.3,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.6,391.8V294c0-11.3,6.3-17.7,17-17.7h61c9.1,0,15,5,15,13.7c0,8.7-6.1,13.7-15,13.7h-44.1v26.5h42.1 c8.2,0,13.7,4.6,13.7,12.5c0,7.8-5.3,12.5-13.7,12.5h-42.1v27.1h44.1c9,0,15,5,15,13.7s-5.9,13.7-15,13.7h-61 C504.9,409.5,498.6,403,498.6,391.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSameButtonBgHover);
export default __webpack_public_path__ + "static/media/same_button_bg-hover.0d1c5e1639b86bc8b42f950126c214d7.svg";
export { ForwardRef as ReactComponent };